import { Injectable, inject } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  InvitePermissionGroupView,
  InvitePermissionSelection,
} from "./invite-permission-selection.interface";

@Injectable()
export class InviteFormModel {
  private formBuilder = inject(FormBuilder);

  public form: FormGroup;

  constructor() {
    this.form = this.formBuilder.group({
      recipientEmail: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
    });
  }

  public initPermissionControls(groups: InvitePermissionGroupView[]): void {
    groups
      .flatMap((group) => group.options)
      .forEach((option) => {
        this.form.addControl(option.controlName, option.control);
      });
  }

  public getSelectedPermissions(
    groups: InvitePermissionGroupView[],
  ): InvitePermissionSelection[] {
    return groups
      .flatMap((group) => group.options)
      .filter((option) => option.control.value)
      .map((option) => ({
        resourceType: option.resourceType,
        permissionCode: option.permissionCode,
      }));
  }
}
